// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1A6rj","header":"Messages_header__Bj17M"};